import React, { useEffect, useState } from "react";
import "./BusinesssetupPage.css";
import { Col, Form, Row } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { LazyLoadImage } from "react-lazy-load-image-component";
import UploadfilesPage from "../../tusimageupload/components/UploadfilesPage";
import close_cross from "../../../assets/close_cross.svg";
import upload_img from "../../../assets/upload_img.png";
import { connect } from "react-redux";
import pdf from "../../../assets/pdf_attachment.svg";
import { useNavigate } from "react-router-dom";
import { formatPhoneNumber } from "../../comman/components/TimeSence";
import DatePicker from "react-datepicker";
import { fetchLogindata } from "../../login/redux/actions";
import { toast } from "react-toastify";
import { getRequestcall } from "../../comman/util/getRequest";
import {
  CREATE_DRIVER,
  DRIVER_DETAIL,
  LIST_VEHICLE,
} from "../../constants/apiurl";
import { postRequestcall } from "../../comman/util/postRequest";
import { FormControl, FormLabel } from "../../comman/formgroup/FormgroupPage";
import ButtonPage from "../../comman/button/ButtonPage";
import AutocompletePlace from "../../comman/components/AutocompletePlace";
import SingleselectPage from "../../comman/customselect/SingleselectPage";

function DriversetupPage(props) {

  const [driverinfo, setDriverinfo] = useState({
    id: "",
    driver_name: "",
    gender: "",
    vehicle_number: "",
    driving_license_number: "",
    number_of_seats: "",
    address: "",
    country: "",
    zip_code: "",
    email: "",
    contact: "",
    national_id: "",
    country_code: "+90",
    country_isocode: "",
    vehicle_type_id: "",
    lat: "",
    lng: "",
  });
  const [hoursfrom, setHoursfrom] = useState(new Date());
  const [hoursto, setHoursto] = useState(new Date());
  const [errors, setErrors] = useState({
    driver_name: "",
    gender: "",
    vehicle_number: "",
    driving_license_number: "",
    number_of_seats: "",
    national_id: "",
    address: "",
    city: "",
    country: "",
    zip_code: "",
    vehicle_images: "",
    license_document: "",
    other_document: ""
  });
  const { t } = useTranslation();
  const navigate = useNavigate();
  // const nameRegex = /^[A-Za-z ığüşöçİĞÜŞÖÇ]+$/;

  const [vehicletype, setVehicletype] = useState({});
  const [vehiclelist, setVehiclelist] = useState([]);

  const [vehicleimage, setVehicleimage] = useState([]);
  const [vehicledocument, setVehicledocument] = useState([]);
  const [otherdocument, setOtherdocument] = useState([]);

  const [noapprove, setNoapprove] = useState(false);
  const [showList, setShowList] = useState(false);

  let time_min = new Date();
  time_min.setHours(1)
  time_min.setMinutes(0)
  var [mintime] = useState(time_min)

  let time_max = new Date();
  time_max.setHours(22)
  time_max.setMinutes(30)
  var [maxtime] = useState(time_max)

  useEffect(() => {
    (async () => vehicleList())();
    // eslint-disable-next-line
  }, []);

  const vehicleList = async () => {
    let getVehiclelist = await getRequestcall(
      LIST_VEHICLE,
      props?.access_token
    );
    if (getVehiclelist?.status === 200) {
      let getResponse = await getVehiclelist.json();
      if (getResponse?.data?.length !== 0) {
        let list = getResponse.data.map((item)=> {
            return {
                value: item.id,
                label: item.vehicle_type,
                label_tr: item.vahicle_type_in_tr,
            }
        });
        setVehiclelist(list);
        if (typeof props?.storeDetail?.vehicle_id !== "undefined" && props?.storeDetail?.vehicle_id !== "") {
          getDriverdetail(list);  // For driver detail edit
        } else {
          showLogininfo(list); // For user become a driver 
        }
      }
     }
  };

  const showLogininfo = (list) => {
    setVehicletype(list[0]);
    setDriverinfo({
      ...driverinfo,
      country_code: props?.logindata?.country_code,
      contact: props?.logindata?.mobile,
      email: props?.logindata?.email,
      vehicle_type_id:list[0]?.value
    });
  };

  const getDriverdetail = async (list) => {
    let geturl = DRIVER_DETAIL + `/${props?.storeDetail?.vehicle_id}`;
    let getDriver = await getRequestcall(geturl, props?.access_token);
    if (getDriver?.status === 200) {
      let driverdetail = await getDriver.json();
      let getVehicletype = list.filter((item) => item.value === driverdetail.data.vehicle_type_id);
      setVehicletype(getVehicletype[0]);
      console.log("driver detail",driverdetail?.data);
      let from = new Date();
      let to = new Date();
      let getFrom = driverdetail.data.working_hours_from.split(":");
      let getTo = driverdetail.data.working_hours_to.split(":");
      from.setHours(getFrom[0], getFrom[1], getFrom[2]);
      setHoursfrom(from);
      to.setHours(getTo[0], getTo[1], getTo[2]);
      setHoursto(to);
      setDriverinfo({
        ...driverdetail?.data,
      });
      bindDocument(driverdetail?.data);
      setNoapprove(false);
    } else if (getDriver?.status === 400) {
      console.log("store detail",props?.storeDetail?.vehicle_id)
      let getResponse = await getDriver.json();
      if (getResponse?.error?.is_deleted) {
        toast.error(getResponse?.errors);
      } else {
        toast.error(getResponse?.errors);
        setNoapprove(true);
      }
    }
  };

  const bindDocument = (getdata) => {
    if (getdata.vehicle_image.length > 0) {
      let images = [];
      getdata.vehicle_image.forEach((item) => {
        let document = {
          preview_url: item,
          fileName: item.split("/").pop(),
        };
        images.push(document);
      });
      setVehicleimage(images);
    }
    if (getdata.vehicle_documents.length > 0) {
      let documents = [];
      getdata.vehicle_documents.forEach((item) => {
        let getExt = item.split(".").pop().toLowerCase();
        let document = {
          preview: getExt === "pdf" ? pdf : item,
          preview_url: item,
          fileName: item.split("/").pop(),
        };
        documents.push(document);
      });
      setVehicledocument(documents);
    }
    if (getdata.other_documents.length > 0) {
      let documents = [];
      getdata.other_documents.forEach((item) => {
        let getExt = item.split(".").pop().toLowerCase();
        let document = {
          preview: getExt === "pdf" ? pdf : item,
          preview_url: item,
          fileName: item.split("/").pop(),
        };
        documents.push(document);
      });
      setOtherdocument(documents);
    }
  };

  const informatioChange = (e) => {
    setDriverinfo({
      ...driverinfo,
      [e.target.name]: e.target.value,
    });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };
  const onChangeRadio = (e, value) => {
    setDriverinfo({
      ...driverinfo,
      [e.target.name]: value,
    });
    setErrors({
      ...errors,
      [e.target.name]: "",
    });
  };

  const locationValueChange = (value) => {
    setDriverinfo({
      ...driverinfo,
      address: value,
    });
  };

  const SetLocation = async ({ place, address, Lat, lng, ZipCode }) => {
    const latitude = Lat;
    const longitude = lng;
    let city = "";
    let country = "";
    place.address_components.forEach((item) => {
      switch (item.types[0]) {
        case "locality":
          city = item.long_name;
          break;
        case "country":
          country = item.long_name;
          break;
        default:
          break;
      }
    });
    setDriverinfo({
      ...driverinfo,
      lat: latitude.toString(),
      lng: longitude.toString(),
      city: city,
      country: country,
      address: address,
      zip_code: ZipCode,
    });
    setErrors({
      ...errors,
      country:"",
      zip_code:""
    });
  }

  const validation = () => {
    let value = true;
    // if (!nameRegex.test(driverinfo.driver_name)) {
    //   errors.driver_name = "pages.signup.fullname_validation";
    //   value = false;
    // }
    if(!driverinfo.driver_name.trim()) {
      errors.driver_name = "pages.setupstore.driver_place";
      value = false;
    }
    if (driverinfo.driver_name === "") {
      console.log("drivername",driverinfo.driver_name)
      errors.driver_name = "pages.setupstore.driver_place";
      value = false;
    }
    if (driverinfo.vehicle_number === "") {
      errors.vehicle_number = "pages.setupstore.vehicle_number_place";
      value = false;
    }
    if (driverinfo.driving_license_number === "") {
      errors.driving_license_number = "pages.setupstore.license_num_place";
      value = false;
    }
    if (driverinfo.number_of_seats === "") {
      errors.number_of_seats = "pages.setupstore.seats_place";
      value = false;
    }
    if (driverinfo.email === "") {
      errors.email = "pages.setupstore.email_address_place";
      value = false;
    }
    if (driverinfo.contact === "") {
      errors.contact = "pages.setupstore.phone_place";
      value = false;
    }
    if (driverinfo.gender === "") {
      errors.gender = "pages.setupstore.select_type";
      value = false;
    }
    if (driverinfo.national_id === "") {
      errors.national_id = "pages.setupstore.national_id_place";
      value = false;
    }
    if (driverinfo.country === "") {
      errors.country = "pages.setupstore.country_place";
      value = false;
    }
    if (driverinfo.zip_code === "") {
      errors.zip_code = "pages.setupstore.pincode_place"
    }
    if (vehicleimage.length === 0) {
      errors.vehicle_images = "pages.setupstore.vehicle_image_place";
      value = false;
    }
    if (vehicledocument.length === 0) {
      errors.license_document = "pages.setupstore.license_document_place";
      value = false;
    }
    if (otherdocument.length === 0) {
      errors.other_document = "pages.setupstore.other_document_place";
      value = false;
    }
    setErrors({
      ...errors,
      driver_name: errors.driver_name,
      vehicle_number: errors.vehicle_number,
      driving_license_number: errors.driving_license_number,
      number_of_seats: errors.number_of_seats,
      email: errors.email,
      contact: errors.contact,
      gender: errors.gender,
      national_id: errors.national_id,
      vehicle_images: errors.vehicle_images,
      license_document: errors.license_document,
      other_document: errors.other_document,
      country: errors.country,
      zip_code: errors.zip_code
    });
    return value;
  };

  const selecteVehicle = (e, vehicle, index) => {
    e.preventDefault();
    setDriverinfo({
      ...driverinfo,
      vehicle_type_id: vehicle.value,
    });
    setVehicletype(vehicle);
  };

  const submitDetail = async (e) => {
    e.preventDefault();
    if (validation()) {
      props?.setLoader(true);
      let vehicle_image = vehicleimage
        .map((item) => {
          return item?.fileName;
        })
        .join(",");
      let vehicle_documents = vehicledocument
        .map((item) => {
          return item?.fileName;
        })
        .join(",");
      let other_documents = otherdocument
        .map((item) => {
          return item?.fileName;
        })
        .join(",");
      let getHoursefrom = new Date(`${hoursfrom}`);
      let fromvalue = getHoursefrom.toLocaleString('en', {
        hour12: false,
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
      })
      let getHourseto = new Date(`${hoursto}`);
      let tovalue = getHourseto.toLocaleString('en', {
        hour12: false,
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
      })
      let driver = {
        id: props.storeDetail.vehicle_id === "" || typeof props.storeDetail.vehicle_id === "undefined" ? "" : props.storeDetail.vehicle_id,
        driver_name: driverinfo?.driver_name,
        vehicle_number: driverinfo?.vehicle_number,
        driving_license_number: driverinfo?.driving_license_number,
        contact: driverinfo?.contact,
        country_code: driverinfo?.country_code,
        gender: driverinfo?.gender,
        email: driverinfo?.email,
        vehicle_image: vehicle_image,
        vehicle_documents: vehicle_documents,
        other_documents: other_documents,
        vehicle_type_id: driverinfo.vehicle_type_id,
        address: driverinfo?.address,
        national_id: driverinfo?.national_id,
        number_of_seats: driverinfo?.number_of_seats,
        country: driverinfo?.country,
        working_hours_from: fromvalue,
        working_hours_to: tovalue,
        lat: driverinfo?.lat,
        lng: driverinfo?.lng,
        zip_code: driverinfo?.zip_code,
      };
      let getVehicleResponse = await postRequestcall(
        CREATE_DRIVER  + `?lang=${props.language.toLowerCase()}`,
        props?.access_token,
        driver
      );
      if (getVehicleResponse?.status === 200) {
        props.logindata.vendor_type = "driver";
        props.logindata.type = "vendor";
        props.fetchLogindata(props.logindata);
        var timestamp = new Date().getTime();
        navigate("/vendor/dashboard", { state: { obj: timestamp } });
        let getError = await getVehicleResponse?.json();
        toast.success(getError?.msg);
        props?.setLoader(false);
      } else if (getVehicleResponse?.status === 400) {
        let getError = await getVehicleResponse?.json();
        window.history.replaceState(null, "", "/vendor/");
        toast.error(getError?.errors);
        props?.setLoader(false);
      } else {
        props?.setLoader(false);
      }
    }
  };

  const timeChange = (date, type) => {
    if (type === "from") {
      setHoursfrom(date);
    } else {
      setHoursto(date);
    }
  };

  const storeFiles = (getImage, type) => {
    if (type === "vehicle_images") {
      let imagevalue = [...vehicleimage];
      imagevalue.push(getImage);
      setVehicleimage(imagevalue);
      setErrors({
          ...errors,
          vehicle_images:""
      })
    } else if (type === "lic_document") {
      let vehilcedocument = [...vehicledocument];
      let getExt = getImage.fileName.split(".").pop().toLowerCase();
      let document = {
        preview: getExt === "pdf" ? pdf : getImage.preview_url,
        preview_url: getImage.preview_url,
        fileName: getImage.fileName,
      };
      vehilcedocument.push(document);
      setVehicledocument(vehilcedocument);
      setErrors({
        ...errors,
        license_document:""
      })
    } else {
      let othdocument = [...otherdocument];
      let getExt = getImage.fileName.split(".").pop().toLowerCase();
      let document = {
        preview: getExt === "pdf" ? pdf : getImage.preview_url,
        preview_url: getImage.preview_url,
        fileName: getImage.fileName,
      };
      othdocument.push(document);
      setOtherdocument(othdocument);
      setErrors({
        ...errors,
        other_document:""
      })
    }
  };

  const closeImage = (getindex, type) => {
    switch (type) {
      case "vehicle_images":
        let updatedImage = vehicleimage.filter(
          (item, index) => index !== getindex
        );
        setVehicleimage(updatedImage);
        break;
      case "lic_document":
        let updatedlicdocument = vehicledocument.filter(
          (item, index) => index !== getindex
        );
        setVehicledocument(updatedlicdocument);
        break;
      case "other_document":
        let updatedother_documents = otherdocument.filter(
          (item, index) => index !== getindex
        );
        setOtherdocument(updatedother_documents);
        break;
      default:
        break;
    }
  };

  const vehicleListrender = (vehiclelist) => {
    let updatedlist = vehiclelist.map((item) => {
      return {
        value: item?.value,
        label: props.language === "Tr" ? item.label_tr : item.label,
        label_tr: item.label_tr,
      }
    });
    return updatedlist;
  };

 const renderSelectedtype = (getItem) => {
    let getValue = vehiclelist.filter((item) => item?.value === getItem?.value);
    if (getValue?.length > 0) {
      return props?.language === "Tr" ? getValue[0]?.label_tr : getValue[0]?.label;
    }else{
       return "";
    }
  }
 
  const clearSelected = () => {
    setVehicletype("");
  }

  return (
    <>
      <Col sm={12} md={12} lg={12} xl={12} className="mb-3">
        <FormLabel label={t("pages.driver_detail.driver_name")} />
        <FormControl placeholder={t("pages.setupstore.driver_place")} value={driverinfo?.driver_name} name={"driver_name"} type={"text"} onChange={(e) => informatioChange(e)} error={t(errors.driver_name)} />
      </Col>
      <Col sm={12} md={12} lg={12} xl={12} className="mb-3">
        <FormLabel label={t("pages.setupstore.gender")} />
        <div className="selection_type">
          <Form.Check
            label={t("pages.setupstore.male")}
            className="radio-btn"
            name="gender"
            id="male"
            type="radio"
            checked={driverinfo.gender === "Male" || driverinfo.gender === "male" ? true : false}
            value={"Male"}
            onChange={(e) => onChangeRadio(e, "Male")}
          />
          <Form.Check
            id="female"
            type="radio"
            checked={driverinfo.gender === "Female" || driverinfo.gender === "female" ? true : false}
            label={t("pages.setupstore.female")}
            name="gender"
            value={"Female"}
            className="radio-btn ms-4"
            onChange={(e) => onChangeRadio(e, "Female")}
          />
        </div>
        <span className="warning text-danger">{t(errors.gender)}</span>
      </Col>
      <Col sm={6} md={6} lg={6} xl={6} className="mb-3 position-relative">
        <FormLabel label={t("pages.setupstore.vehicle_type")} />
         <SingleselectPage
          groupItemClick={selecteVehicle}
          list={vehicleListrender(vehiclelist)}
          setShowList={setShowList}
          showList={showList}
          placeholder={t("pages.vehicle_list.select_cab_type")}
          value={renderSelectedtype(vehicletype)}
          clearSelected={clearSelected}
        /> 
      </Col>
      <Col sm={6} md={6} lg={6} xl={6} className={"mb-3"}>
        <FormLabel label={t("pages.setupstore.vehicle_number")} />
        <FormControl placeholder={t("pages.setupstore.vehicle_number_place")} value={driverinfo?.vehicle_number} name={"vehicle_number"} type={"text"} onChange={(e) => informatioChange(e)} error={t(errors.vehicle_number)} />
      </Col>
      <Col sm={6} md={6} lg={6} xl={6} className="mb-3">
        <FormLabel label={t("pages.setupstore.number_seats")} />
        <FormControl placeholder={t("pages.setupstore.seats_place")} value={driverinfo?.number_of_seats} name={"number_of_seats"} type={"text"} onChange={(e) => informatioChange(e)} error={t(errors.number_of_seats)} />
      </Col>
      <Col sm={6} md={6} lg={6} xl={6} className="mb-3">
        <FormLabel label={t("pages.setupstore.license_number")} />
        <FormControl placeholder={t("pages.setupstore.license_num_place")} value={driverinfo?.driving_license_number} name={"driving_license_number"} type={"text"} onChange={(e) => informatioChange(e)} error={t(errors.driving_license_number)} />
      </Col>
      <Col sm={6} md={6} lg={6} xl={6} className="mb-3">
        <Row>
          <Col sm={3} md={3} lg={3} xl={6}>
            <FormLabel label={t("pages.setupstore.working_hrs")} />
            <DatePicker
              locale={props?.language.toLowerCase()}
              selected={hoursfrom}
              onChange={(date) => timeChange(date, "from")}
              className="hourstime"
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={30}
              timeFormat="HH:mm a"
              dateFormat="HH:mm aa"
              timeCaption="Time"
              minTime={mintime}
              maxTime={maxtime}
            />
          </Col>
          <Col sm={3} md={3} lg={3} xl={6}>
            <FormLabel label={t("pages.setupstore.working_to")} />
            <DatePicker
              locale={props?.language.toLowerCase()}
              selected={hoursto}
              onChange={(date) => timeChange(date, "to")}
              className="hourstime"
              showTimeSelect
              showTimeSelectOnly
              timeIntervals={30}
              timeFormat="HH:mm a"
              dateFormat="HH:mm aa"
              timeCaption="Time"
              minTime={mintime}
              maxTime={maxtime}
            />
          </Col>
        </Row>
      </Col>
      <Col sm={6} md={6} lg={6} xl={6} className="mb-3">
        <FormLabel label={t("pages.setupstore.address")} />
        <AutocompletePlace
          setAddress={locationValueChange}
          address={driverinfo.address}
          placaddress={t("pages.setupstore.address_place")}
          SetLocation={SetLocation}
          className={"bussinesssetup-location"}
        />
      </Col>
      <Col sm={6} md={6} lg={6} xl={6} className="mb-3">
        <FormLabel label={t("pages.setupstore.country")} />
        <FormControl placeholder={t("pages.setupstore.country_place")} value={driverinfo?.country} name={"country"} type={"text"} onChange={(e) => informatioChange(e)} error={t(errors?.country)} />
      </Col>
      <Col sm={6} md={6} lg={6} xl={6} className="mb-3">
        <FormLabel label={t("pages.setupstore.pincode")} />
        <FormControl placeholder={t("pages.setupstore.pincode_place")} value={driverinfo?.zip_code} name={"zip_code"} type={"text"} onChange={(e) => informatioChange(e)} error={t(errors?.zip_code)} />
      </Col>
      <Col sm={6} md={6} lg={6} xl={6} className="mb-3">
        <FormLabel label={t("pages.setupstore.national_id")} />
        <FormControl placeholder={t("pages.setupstore.national_id_place")} value={driverinfo?.national_id} name={"national_id"} type={"number"} onChange={(e) => informatioChange(e)} error={t(errors?.national_id)} />
      </Col>
      <Col sm={6} md={6} lg={6} xl={6} className="mb-3">
        <FormLabel label={t("pages.setupstore.email_address")} />
        <FormControl placeholder={t("pages.setupstore.email_address_place")} disabled={true} value={driverinfo?.email} name={"email"} type={"text"} error={t(errors?.email)} />
      </Col>
      <Col sm={6} md={6} lg={6} xl={6} className="mb-3">
        <FormLabel label={t("pages.setupstore.phone")} />
        <FormControl placeholder={t("pages.setupstore.mobile_place")} value={driverinfo.country_code + " " + formatPhoneNumber(driverinfo.contact)} name={"contact"} type={"text"} disabled={true} />
      </Col>
      <Col sm={12} md={12} lg={12} xl={12} className="pb-4 upload-profiles">
        <FormLabel label={t("pages.setupstore.vehicle_image")} />
        <div className="multi-upload-img">
          <UploadfilesPage storeFiles={storeFiles} type={"vehicle_images"} />
        </div>
        {vehicleimage?.map((item, index) => (
          <div className="multi-upload-img" key={index?.toString()} style={{ marginBottom: "20px" }}>
            <img
              src={close_cross}
              className="close-icon"
              alt="close"
              onClick={() => closeImage(index, "vehicle_images")}
            ></img>
            <LazyLoadImage
              src={item?.preview_url}
              onError={(e) => {
                e.target.src = upload_img;
              }}
              className="product-img"
              alt=""
              onClick={() => window.open(item?.preview_url, "_blank")}
            ></LazyLoadImage>
          </div>
        ))}
      </Col>
      <span className="warning text-danger">{t(errors.vehicle_images)}</span>
      <Col sm={12} md={12} lg={12} xl={12} className="pb-4 upload-profiles">
        <FormLabel label={t("pages.setupstore.document")} />
        <div className="multi-upload-img">
          <UploadfilesPage storeFiles={storeFiles} type={"lic_document"} />
        </div>
        {vehicledocument?.map((item, index) => (
          <div className="multi-upload-img" key={index?.toString()} style={{ marginBottom: "20px" }}>
            <img
              src={close_cross}
              className="close-icon"
              alt="close"
              onClick={() => closeImage(index, "lic_document")}
            ></img>
            <LazyLoadImage
              src={item?.preview}
              onError={(e) => {
                e.target.src = upload_img;
              }}
              className="product-img"
              alt=""
              onClick={() => window.open(item?.preview_url, "_blank")}
            ></LazyLoadImage>
          </div>
        ))}
      </Col>
      <span className="warning text-danger">{t(errors.license_document)}</span>
      <Col sm={12} md={12} lg={12} xl={12} className="pb-4 upload-profiles">
        <FormLabel label={t("pages.setupstore.other_document")} />
        <div className="multi-upload-img">
          <UploadfilesPage storeFiles={storeFiles} type={"other_document"} />
        </div>
        {otherdocument?.map((item, index) => (
          <div className="multi-upload-img" key={index?.toString()} style={{ marginBottom: "20px" }}>
            <img
              src={close_cross}
              className="close-icon"
              alt="close"
              onClick={() => closeImage(index, "other_document")}
            ></img>
            <LazyLoadImage
              src={item?.preview}
              onError={(e) => {
                e.target.src = upload_img;
              }}
              className="product-img"
              alt=""
              onClick={() => window.open(item?.preview_url, "_blank")}
            ></LazyLoadImage>
          </div>
        ))}
      </Col>
      <span className="warning text-danger">{t(errors.other_document)}</span>
      <Col sm={12} md={12} lg={12} xl={12} className="d-flex justify-content-end">
        {!noapprove && (
          <ButtonPage
            Text={
              t("pages.setupstore.submit_detail")
            }
            onClick={(e) => submitDetail(e)}
            className={`button-submit m-2 hover-btn`}
            type={"submit"}
          />
        )}
      </Col>
    </>
  );
}

const mapStateToProps = (state) => ({
  access_token: state?.login?.access_token,
  logindata: state?.login?.logindata,
  storeDetail: state?.dashboard?.storeDetail,
  currentLocation: state?.home?.currentLocation,
  language: state?.languageState?.language,
});

export default connect(mapStateToProps, { fetchLogindata })(DriversetupPage);
